import { RouteRecordRaw } from 'vue-router'

export const wandaRoutes: RouteRecordRaw[] = [
  {
    path: '/wanda',
    name: 'WandaDashboard',
    component: () =>
      import(
        /* webpackChunkName: "wanda" */
        '@/views/wanda/Dashboard.vue'
      ),
    meta: {
      title: 'Wanda - Dashboard',
      onlyLoggedIn: true
    }
  },
  {
    path: '/wanda/form/:id?',
    name: 'WandaCreateEventForm',
    component: () =>
      import(
        /* webpackChunkName: "wanda-create-event" */
        '@/views/wanda/CreateEvent.vue'
      ),
    meta: {
      title: 'Wanda - Criação de evento',
      onlyLoggedIn: true
    },
    beforeEnter: (to, from, next) => {
      if (to.params.id) document.title = 'Wanda - Atualização de evento'
      next()
    }
  },
  {
    path: '/healthcare_map',
    name: 'HealthcareMap',
    component: () =>
      import(
        /* webpackChunkName: "healthcare-map" */
        '@/views/healthcareMap/Home.vue'
      ),
    meta: {
      title: 'Mapa do cuidado',
      onlyLoggedIn: true
    }
  },
  {
    path: '/healthcare_map/:healthcareTeamId/overview',
    name: 'HealthcareMapOverview',
    component: () =>
      import(
        /* webpackChunkName: "healthcare-map-overview" */
        '@/views/healthcareMap/Overview.vue'
      ),
    meta: {
      title: 'Mapa do Cuidado - Overview',
      onlyLoggedIn: true
    }
  },
  {
    path: '/healthcare_map/:healthcareTeamId/result',
    name: 'HealthcareTeamMapResult',
    component: () =>
      import(
        /* webpackChunkName: "healthcare-map-result" */
        '@/views/healthcareMap/Result.vue'
      ),
    meta: {
      title: 'Mapa do Cuidado - Carteira',
      onlyLoggedIn: true
    }
  }
]
